/*
  Preventa — mantener el botón y el aviso al cambiar de variante.

  Al elegir otra talla, Dawn vuelve a pedir la sección al servidor (que ya
  devuelve "Reservar en preventa" y el aviso de los días) pero acto seguido pisa
  el texto del botón con window.variantStrings.addToCart. Sin esto, la talla
  agotada que se vende por encargo diría "Agregar al carrito" y el cliente no se
  enteraría de la espera hasta que le llegara el correo.

  No toca el caso "Agotado": si la variante no se puede comprar, Dawn ya
  desactiva el botón y ese texto es el correcto.
*/
(function () {
  function actualizar(datos) {
    var html = datos.html;
    if (!html) return;

    var info =
      document.querySelector('product-info[data-section="' + datos.sectionId + '"]') ||
      document.querySelector('product-info');
    if (!info) return;

    var botonNuevo = html.getElementById('ProductSubmitButton-' + datos.sectionId);
    var boton = info.querySelector('.product-form__submit');

    if (boton && botonNuevo && !botonNuevo.hasAttribute('disabled')) {
      var textoNuevo = botonNuevo.querySelector('span');
      var texto = boton.querySelector('span');
      if (textoNuevo && texto) texto.textContent = textoNuevo.textContent.trim();
    }

    var avisoNuevo = html.querySelector('.marca-preventa__aviso');
    var aviso = info.querySelector('.marca-preventa__aviso');

    if (avisoNuevo && !aviso) {
      var botones = info.querySelector('.product-form__buttons');
      if (botones) botones.insertAdjacentHTML('afterend', avisoNuevo.outerHTML);
    } else if (!avisoNuevo && aviso) {
      aviso.remove();
    }
  }

  function arrancar() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;
    subscribe(PUB_SUB_EVENTS.variantChange, function (evento) {
      actualizar((evento && evento.data) || {});
    });
    return true;
  }

  if (!arrancar()) document.addEventListener('DOMContentLoaded', arrancar);
})();
